/*
    This is used to mock the window object during unit testing. See https://dev.to/grug/mocking-the-window-object-in-unit-tests-1h2e
 */
const windowRef = window
export { windowRef as window }
